import React, { lazy, useEffect, useState } from 'react'
import { ConnectedRouter } from 'connected-react-router'
import { Switch } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import _ from 'lodash'
import { GlobalStyle } from './GlobalStyle'
import { history } from '../../utils/history'
import { AuthRoute } from './AuthRoute'
import * as route from '../../routes'
import { SuspenceFallback } from './SuspanceFallback'
import { OnlyUnauthRoute } from './OnlyUnauthRoute'
import { isLoggedIn } from '../../features/session/selector'
import { SessionActions } from '../../features/session/actions'
import Themes from '../../pages/Themes'
import Hooks from '../../pages/Hooks'
import AddTheme from '../../pages/Themes/ThemeWizard'
import AddHook from '../../pages/Hooks/HookWizard'
import Profiles from '../../pages/Profiles'
import Stats from '../../pages/Stats'
import UserChats from '../../pages/UserChats'
import { refreshToken } from '../../api/user'
import { setAccessToken } from '../../utils/token'
import { EditProfile } from '../../pages/Profiles/EditProfile'
import Flows from '../../pages/Flows'
import AddFlow from '../../pages/Flows/FlowWizard'
import PaymentTemplates from '../../pages/PaymentTemplates'
// import { session } from '../../features/session/selector'

const Dashboard = lazy(() => import('../../pages/Dashboard'))
const Login = lazy(() => import('../../pages/Login'))

const App = () => {
  // const isUserLoggedIn = useSelector(isLoggedIn)
  const isUserLoggedIn = useSelector(isLoggedIn)

  const dispatch = useDispatch()
  const [loading, setLoading] = useState(true)

  // useEffect(() => {
  //   function checkSession() {
  //     const uid = cookies.get('uid')
  //     if (uid) {
  //       dispatch(SessionActions.restoreSession())
  //     }
  //     setLoading(false)
  //   }
  //   checkSession()
  // }, [dispatch])
  useEffect(() => {
    async function checkToken() {
      const getToken = localStorage.getItem('refresh_token')
      if (getToken) {
        const response = await refreshToken(getToken)
        const tk = _.get(response, 'data.accessToken')
        if (tk) {
          setAccessToken(tk)
          dispatch(SessionActions.restoreSession())
        }
      }

      setLoading(false)
    }
    checkToken()
  }, [dispatch])

  if (loading) {
    return <div>loading</div>
  }

  return (
    <ConnectedRouter history={history}>
      <SuspenceFallback>
        <Switch>
          <AuthRoute loggedIn={isUserLoggedIn} path={route.DASHBOARD} exact component={Dashboard} />
          <AuthRoute loggedIn={isUserLoggedIn} exact path={route.THEMES} component={Themes} />
          <AuthRoute loggedIn={isUserLoggedIn} exact path={route.HOOKS} component={Hooks} />
          <AuthRoute loggedIn={isUserLoggedIn} exact path={route.FLOWS} component={Flows} />
          <AuthRoute loggedIn={isUserLoggedIn} exact path={route.PROFILES} component={Profiles} />
          <AuthRoute loggedIn={isUserLoggedIn} exact path={route.PAYMENT_TEMPLATES} component={PaymentTemplates} />
          {/* <AuthRoute loggedIn={isUserLoggedIn} exact path={route.ADD_PROFILE} component={EditProfile} /> */}
          <AuthRoute loggedIn={isUserLoggedIn} exact path={route.EDIT_PROFILE} component={EditProfile} />
          <AuthRoute loggedIn={isUserLoggedIn} exact path={route.STATS} component={Stats} />
          <AuthRoute loggedIn={isUserLoggedIn} exact path={route.USER_CHATS} component={UserChats} />
          <AuthRoute loggedIn={isUserLoggedIn} exact path={route.THEME_DETAIL} component={AddTheme} />
          <AuthRoute loggedIn={isUserLoggedIn} exact path={route.ADD_THEME} component={AddTheme} />
          <AuthRoute loggedIn={isUserLoggedIn} exact path={route.HOOK_DETAIL} component={AddHook} />
          <AuthRoute loggedIn={isUserLoggedIn} exact path={route.ADD_HOOK} component={AddHook} />
          <AuthRoute loggedIn={isUserLoggedIn} exact path={route.ADD_FLOW} component={AddFlow} />
          <AuthRoute loggedIn={isUserLoggedIn} exact path={route.FLOW_DETAIL} component={AddFlow} />
          <OnlyUnauthRoute loggedIn={isUserLoggedIn} path={route.LOGIN} redirect={route.DASHBOARD} component={Login} />
        </Switch>
      </SuspenceFallback>

      <GlobalStyle />
    </ConnectedRouter>
  )
}

// eslint-disable-next-line import/no-default-export
export default App
